module.exports = __webpack_public_path__ + "static/img/img_welecome.0f78520b.png";